import React, { useState, useRef } from 'react';
import axios from 'axios';
import './payment.css';
import env from "../../env.json";

const FileUploadPage = () => {
  const { BASE_URL } = env;
  const [paymentMode, setPaymentMode] = useState('Online'); // 'Online' or 'Cash'

  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [transactionFile, setTransactionFile] = useState(null);
  // day/week grouping for backend processing
  const [dateMode, setDateMode] = useState('day'); // 'day' or 'week'
  const [settlementFiles, setSettlementFiles] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [progress, setProgress] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [transactionPreview, setTransactionPreview] = useState('');
  const [settlementPreviews, setSettlementPreviews] = useState([]);
  const [showPreviews, setShowPreviews] = useState(false);

  const settlementRef = useRef(null);
  const transactionRef = useRef(null);

  console.log('in the file file FileUploadPage',)

  const handleTransactionUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setTransactionFile(file);
    setTransactionPreview(await readFileContent(file));
  };

  const handleSettlementUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    setSettlementFiles(files);
    const previews = await Promise.all(files.map(readFileContent));
    setSettlementPreviews(previews);
  };

  // const readFileContent = (file) => {
  //   return new Promise((resolve) => {
  //     const reader = new FileReader();
  //     reader.onload = (e) => {
  //       const content = e.target.result;
  //       const lines = content.split('\n');
  //       resolve(lines.slice(0, 100).join('\n'));
  //     };
  //     reader.readAsText(file);
  //   });
  // };


  const clearAllFiles = () => {
    setSettlementFiles([]);
    setSettlementPreviews([]);
    if (settlementRef.current) {
      settlementRef.current.value = '';
    }
  };






  const readFileContent = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        const content = e.target.result;
        console.log(`✅ Loaded ${file.name}: ${content.length} chars, ${content.split(/\r?\n/).length} lines`);
        
        // Validate file was fully loaded
        const ratio = content.length / file.size;
        if (ratio < 0.8) {
          console.warn(`⚠️ ${file.name} may be truncated. Size ratio: ${ratio.toFixed(3)}`);
        }
        
        resolve(content); // Return FULL content, not just 100 lines
      };
      
      reader.onerror = (error) => {
        console.error(`❌ Error reading ${file.name}:`, error);
        reject(error);
      };
      
      reader.readAsText(file);
    });
  };
  

  // const combineSettlementFiles = () => {
  //   if (settlementFiles.length === 0) return null;

  //   let combinedContent = '';
  //   settlementFiles.forEach((file, index) => {
  //     if (index === 0) {
  //       combinedContent = settlementPreviews[index];
  //     } else {
  //       const contentWithoutHeader = settlementPreviews[index].split('\n').slice(1).join('\n');
  //       combinedContent += '\n' + contentWithoutHeader;
  //     }
  //   });

  //   const blob = new Blob([combinedContent], { type: 'text/csv' });
  //   return new File([blob], 'combined_settlement.csv', { type: 'text/csv' });
  // };






  // const combineSettlementFiles = () => {
  //   if (settlementFiles.length === 0) return null;
  
  //   let combinedContent = '';
  //   settlementFiles.forEach((file, index) => {
  //     const content = settlementPreviews[index];
  //     if (!content) return;
  
  //     if (index === 0) {
  //       // keep the header of the first file
  //       combinedContent = content;
  //     } else {
  //       // remove header row of subsequent files
  //       const contentWithoutHeader = content.split('\n').slice(1).join('\n');
  //       combinedContent += '\n' + contentWithoutHeader;
  //     }
  //   });
  
  //   const blob = new Blob([combinedContent], { type: 'text/csv' });
  //   return new File([blob], 'combined_settlement.csv', { type: 'text/csv' });
  // };










  const combineSettlementFiles = () => {
    if (settlementFiles.length === 0) return null;
  
    let combinedContent = '';
    let totalRowCount = 0;
    let headerRowCount = 0;
    
    console.log(`🔄 Combining ${settlementFiles.length} files...`);
    console.log(`📋 Initial Debug Check:`);
    
    // COMPREHENSIVE DEBUG CHECK
    settlementFiles.forEach((file, index) => {
      const content = settlementPreviews[index];
      console.log(`\n🔍 File ${index + 1} Analysis:`);
      console.log(`   File name: ${file.name}`);
      console.log(`   Original file size: ${file.size} bytes`);
      console.log(`   Preview exists: ${!!content}`);
      console.log(`   Preview content length: ${content?.length || 'N/A'} characters`);
      
      if (content) {
        const allLines = content.split(/\r?\n/);
        const nonEmptyLines = allLines.filter(line => line.trim() !== '');
        console.log(`   Total lines (including empty): ${allLines.length}`);
        console.log(`   Non-empty lines: ${nonEmptyLines.length}`);
        console.log(`   First line preview: "${allLines[0]?.substring(0, 100)}..."`);
        console.log(`   Last line preview: "${allLines[allLines.length - 1]?.substring(0, 100)}..."`);
        
        // Check for potential issues
        const emptyLines = allLines.length - nonEmptyLines.length;
        if (emptyLines > 0) {
          console.log(`   ⚠️ Contains ${emptyLines} empty lines`);
        }
        
        // Check file size vs content ratio
        const ratio = content.length / file.size;
        console.log(`   Content/Size ratio: ${ratio.toFixed(3)} (should be ~1.0)`);
        if (ratio < 0.9) {
          console.warn(`   🚨 Content appears truncated! Expected ~${file.size} chars, got ${content.length}`);
        }
      } else {
        console.error(`   ❌ No content found for file ${index + 1}`);
      }
    });
  
    console.log(`\n🔧 Starting combination process...`);
    
    settlementFiles.forEach((file, index) => {
      const content = settlementPreviews[index];
      
      if (!content) {
        console.error(`⚠️ File ${index + 1}: No content found - SKIPPING`);
        return;
      }
  
      // Split content into lines and filter out empty lines
      const allLines = content.split(/\r?\n/);
      const lines = allLines.filter(line => line.trim() !== '');
      
      console.log(`\n📁 Processing File ${index + 1} (${file.name}):`);
      console.log(`   Raw lines (with empty): ${allLines.length}`);
      console.log(`   Non-empty lines: ${lines.length}`);
      console.log(`   Empty lines filtered: ${allLines.length - lines.length}`);
      
      if (lines.length === 0) {
        console.warn(`   ⚠️ No valid lines found in file ${index + 1}`);
        return;
      }
      
      if (index === 0) {
        // Keep the header of the first file
        combinedContent = lines.join('\n');
        headerRowCount = 1;
        totalRowCount += lines.length;
        console.log(`   ✅ Added header + ${lines.length - 1} data rows`);
        console.log(`   Running total: ${totalRowCount} rows`);
      } else {
        // Remove header row of subsequent files (skip first line)
        const dataLines = lines.slice(1);
        console.log(`   Header line (skipped): "${lines[0]?.substring(0, 50)}..."`);
        
        if (dataLines.length > 0) {
          const previousLength = combinedContent.split(/\r?\n/).length;
          combinedContent += '\n' + dataLines.join('\n');
          totalRowCount += dataLines.length;
          const newLength = combinedContent.split(/\r?\n/).length;
          
          console.log(`   ✅ Added ${dataLines.length} data rows (header skipped)`);
          console.log(`   Combined content grew from ${previousLength} to ${newLength} lines`);
          console.log(`   Running total: ${totalRowCount} rows`);
        } else {
          console.warn(`   ⚠️ No data rows to add (only header found)`);
        }
      }
    });
  
    // Final validation with detailed analysis
    const finalLines = combinedContent.split(/\r?\n/).filter(line => line.trim() !== '');
    const allFinalLines = combinedContent.split(/\r?\n/);
    
    console.log(`\n📊 Final Combined File Analysis:`);
    console.log(`   Total files processed: ${settlementFiles.length}`);
    console.log(`   Header rows: ${headerRowCount}`);
    console.log(`   Data rows: ${totalRowCount - headerRowCount}`);
    console.log(`   Expected total: ${totalRowCount}`);
    console.log(`   Actual total (non-empty): ${finalLines.length}`);
    console.log(`   Actual total (all lines): ${allFinalLines.length}`);
    console.log(`   Combined content length: ${combinedContent.length} characters`);
    
    // Detailed mismatch analysis
    if (finalLines.length !== totalRowCount) {
      const difference = totalRowCount - finalLines.length;
      console.error(`❌ Row count mismatch!`);
      console.error(`   Expected: ${totalRowCount}`);
      console.error(`   Got: ${finalLines.length}`);
      console.error(`   Missing: ${difference} rows`);
      
      // Try to identify where the issue occurred
      console.log(`\n🔍 Debugging the mismatch:`);
      console.log(`   Combined content preview (first 200 chars): "${combinedContent.substring(0, 200)}"`);
      console.log(`   Combined content preview (last 200 chars): "${combinedContent.substring(combinedContent.length - 200)}"`);
      
      // Check if there are issues with line breaks
      const linesWithR = combinedContent.split('\r\n').length;
      const linesWithN = combinedContent.split('\n').length;
      console.log(`   Lines when split by \\r\\n: ${linesWithR}`);
      console.log(`   Lines when split by \\n: ${linesWithN}`);
    } else {
      console.log(`✅ Row count verified: ${totalRowCount} rows`);
    }
    
    // Additional blob creation debug
    const blob = new Blob([combinedContent], { type: 'text/csv' });
    console.log(`📦 Created blob: ${blob.size} bytes`);
    
    const file = new File([blob], 'combined_settlement.csv', { type: 'text/csv' });
    console.log(`📄 Created file: ${file.name}, ${file.size} bytes`);
    
    return file;
  };
  
  
  
  


  // const processFiles = async () => {
  //   setIsProcessing(true);
  //   setError('');
  //   setSuccess('');
  //   setProgress(0);

  //   try {
  //     if (paymentMode === 'Cash') {
  //       if (!fromDate || !toDate) {
  //         setError('Please select both From and To dates');
  //         return;
  //       }

  //       // await axios.post('http://localhost:8080/processCashPayments', {
  //       await axios.post('https://admin-api.cruze.asia/processCashPayments', {
  //         fromDate,
  //         toDate,
  //       });

  //       setSuccess('Cash payments processed successfully!');
  //     } else {
  //       if (!transactionFile || settlementFiles.length === 0) {
  //         setError('Please upload both transaction and settlement files');
  //         return;
  //       }

  //       const formData = new FormData();
  //       formData.append('transactionFile', transactionFile);

  //       const settlementFileToSend =
  //         settlementFiles.length > 1 ? combineSettlementFiles() : settlementFiles[0];

  //       formData.append('settlementFile', settlementFileToSend);

  //       // await axios.post('http://localhost:8080/processPaymentFiles', formData, {
  //       await axios.post('https://admin-api.cruze.asia/processPaymentFiles', formData, {
  //         onUploadProgress: (e) => {
  //           setProgress(Math.round((e.loaded * 100) / e.total));
  //         },
  //       });

  //       setSuccess('Online files processed successfully!');
  //     }
  //   } catch (err) {
  //     setError(err.response?.data?.message || 'Error processing files');
  //   } finally {
  //     setIsProcessing(false);
  //   }
  // };










  const processFiles = async () => {
    setIsProcessing(true);
    setError('');
    setSuccess('');
    setProgress(0);
  
    try {
      if (paymentMode === 'Cash') {
        if (!fromDate || !toDate) {
          setError('Please select both From and To dates');
          return;
        }
  
        // await axios.post('https://admin-api.cruze.asia/processCashPayments', {
        // await axios.post('http://localhost:8080/processCashPayments', {
        await axios.post(`${BASE_URL}/processCashPayments`, {
          fromDate,
          toDate,
        });
  
        setSuccess('Cash payments processed successfully!');
      } else {
        // ✅ Settlement only (no transaction file)
        if (settlementFiles.length === 0) {
          setError('Please upload at least one settlement file');
          return;
        }
  
        const formData = new FormData();

        // send the selected grouping so backend can decide day/week logic
        formData.append('dateMode', dateMode);
  
        const settlementFileToSend =
          settlementFiles.length > 1 ? combineSettlementFiles() : settlementFiles[0];
  
        formData.append('settlementFile', settlementFileToSend);
  
        // await axios.post('https://admin-api.cruze.asia/processPaymentFiles', formData, {
        // await axios.post('http://localhost:8080/processPaymentFiles', formData, {
        await axios.post(`${BASE_URL}/processPaymentFiles`, formData, {
          onUploadProgress: (e) => {
            setProgress(Math.round((e.loaded * 100) / e.total));
          },
        });
  
        setSuccess('Settlement file(s) processed successfully!');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error processing files');
    } finally {
      setIsProcessing(false);
    }
  };
  







  const removeTransactionFile = () => {
    setTransactionFile(null);
    setTransactionPreview('');
    if (transactionRef.current) transactionRef.current.value = '';
  };

  const removeSettlementFile = (index) => {
    const newFiles = [...settlementFiles];
    newFiles.splice(index, 1);
    setSettlementFiles(newFiles);

    const newPreviews = [...settlementPreviews];
    newPreviews.splice(index, 1);
    setSettlementPreviews(newPreviews);

    if (newFiles.length === 0 && settlementRef.current) {
      settlementRef.current.value = '';
    }
  };

  const canProcess =
    (paymentMode === 'Cash' && fromDate && toDate) ||
    (paymentMode === 'Online' && settlementFiles.length > 0);

  return (
    <div className="container mx-auto max-w-3xl p-4">
      <h1 className="text-2xl font-bold mb-6">Upload Payment Files</h1>

      {/* Payment Mode Selection */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">Select Payment Mode</label>
        <div className="flex gap-4">
          <button
            onClick={() => setPaymentMode('Online')}
            className={`px-4 py-2 rounded-md ${paymentMode === 'Online'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700'
              }`}
          >
            Online
          </button>
          <button
            onClick={() => setPaymentMode('Cash')}
            className={`px-4 py-2 rounded-md ${paymentMode === 'Cash'
              ? 'bg-blue-600 text-white'
              : 'bg-gray-200 text-gray-700'
              }`}
          >
            Cash
          </button>
        </div>
      </div>

      {/* Date Grouping Selection - only for Online */}
      {paymentMode === 'Online' && (
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Grouping</label>
          <div className="flex items-center gap-6">
            <label className="inline-flex items-center gap-2">
              <input
                type="radio"
                name="dateMode"
                value="day"
                checked={dateMode === 'day'}
                onChange={(e) => setDateMode(e.target.value)}
              />
              <span>Day-wise</span>
            </label>
            <label className="inline-flex items-center gap-2">
              <input
                type="radio"
                name="dateMode"
                value="week"
                checked={dateMode === 'week'}
                onChange={(e) => setDateMode(e.target.value)}
              />
              <span>Week-wise</span>
            </label>
          </div>
        </div>
      )}

      {/* Cash Mode Inputs */}
      {paymentMode === 'Cash' && (
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Date Range</label>
          <div className="flex gap-4">
            <input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              className="border p-2 rounded"
            />
            <input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              className="border p-2 rounded"
            />
          </div>
        </div>
      )}

      {/* Online Mode File Uploads */}
      {paymentMode === 'Online' && (
        <>
          {/* Transaction File Upload */}
          {/* <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Transaction File (Single File)
            </label>
            <div className="flex items-center">
              <input
                type="file"
                ref={transactionRef}
                onChange={handleTransactionUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
            {transactionFile && (
              <div className="mt-3 p-3 bg-gray-50 rounded-md">
                <div className="flex justify-between items-center">
                  <p className="text-sm text-gray-600">
                    Selected: {transactionFile.name}
                    <button
                      onClick={removeTransactionFile}
                      className="ml-2 text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  </p>
                  <button
                    onClick={() => setShowPreviews(!showPreviews)}
                    className="text-blue-500 text-sm"
                  >
                    {showPreviews ? 'Hide Preview' : 'Show Preview'}
                  </button>
                </div>
                {showPreviews && transactionPreview && (
                  <div className="mt-3">
                    <h4 className="text-sm font-medium mb-1">Preview:</h4>
                    <pre className="text-xs bg-white p-2 border rounded-md max-h-40 overflow-auto">
                      {transactionPreview}
                    </pre>
                  </div>
                )}
              </div>
            )}
          </div> */}

          {/* Settlement Files Upload */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Settlement Files (Multiple Files Accepted)
            </label>
            <div className="flex items-center">
              <input
                type="file"
                ref={settlementRef}
                multiple
                onChange={handleSettlementUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
            {settlementFiles.length > 0 && (
              <div className="mt-3 bg-gray-50 rounded-md p-3">
                <p className="text-sm text-gray-600 mb-2">
                  {settlementFiles.length} file(s) selected
                  {settlementFiles.length > 1 && (
                    <span className="ml-2 text-blue-500">
                      (Files will be combined during processing)
                    </span>
                  )}
                </p>
                {settlementFiles.map((file, index) => (
                  <div key={index} className="mb-3 last:mb-0">
                    <div className="flex justify-between items-center">
                      <p className="text-sm">
                        {file.name}
                        <button
                          onClick={() => removeSettlementFile(index)}
                          className="ml-2 text-red-500 hover:text-red-700"
                        >
                          Remove
                        </button>
                      </p>
                    </div>
                    {showPreviews && settlementPreviews[index] && (
                      <div className="mt-2">
                        <h4 className="text-xs font-medium mb-1">Preview:</h4>
                        <pre className="text-xs bg-white p-2 border rounded-md max-h-40 overflow-auto">
                          {settlementPreviews[index]}
                        </pre>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}

      {/* Process Button */}
      <div className="flex justify-end">
        <button
          onClick={processFiles}
          disabled={isProcessing || !canProcess}
          className={`px-4 py-2 rounded-md text-white ${isProcessing || !canProcess
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-blue-600 hover:bg-blue-700'
            }`}
        >
          {isProcessing ? 'Processing...' : 'Process Files'}
        </button>
      </div>

      {/* Progress and Status */}
      {isProcessing && (
        <div className="mt-6">
          <div className="w-full bg-gray-200 rounded-full h-2.5">
            <div
              className="bg-blue-600 h-2.5 rounded-full"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <p className="mt-2 text-sm text-gray-600">Processing... {progress}%</p>
        </div>
      )}

      {error && (
        <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-md">{error}</div>
      )}

      {success && (
        <div className="mt-4 p-3 bg-green-100 text-green-700 rounded-md">{success}</div>
      )}



{/* 
// Add this button in your JSX */}
{settlementFiles.length > 0 && (
  <button
    onClick={clearAllFiles}
    className="mt-2 px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600"
  >
    Clear All Files
  </button>
)}
    </div>
  );
};

export default FileUploadPage;













